// extracted by mini-css-extract-plugin
module.exports = {"div":"pagination_div__LIC40","button":"pagination_button__mhRyD"};